<template>
    <section id="password-reminder" class="container mt-5 mb-5">
        <div class="set-password__container mt-5 mb-5" v-if="emailReminded === false">
            <h3 class="title-content">{{ $t('FORGOT_PASSWORD') }}</h3>
            <p class="set-password__heading">{{ $t('ENTER_REGISTER_EMAIL') }}</p>
            <form class="form--main mt-5 mb-5">
                <div class="form-group">
                    <div class="control">
                        <p v-if="errors.has('email')" class="validate-danger">
                            <img src="./../../../assets/images/icons/excl-red.svg" />
                            {{ $t('COMPLETE_FIELDS_CORRECTLY') }}
                        </p>
                        <input
                            id="loginEmail"
                            v-model="loginEmail"
                            v-validate="{ required: true, regex: emailRegex }"
                            data-vv-validate-on="none"
                            :class="{ validate: errors.has('email') }"
                            class="text-input -white-input-border"
                            name="email"
                            :placeholder="$t('EMAIL_ADDRESS')"
                            type="text"
                        />
                    </div>
                </div>
                <vue-recaptcha
                    v-show="showCaptcha"
                    :sitekey="siteKey"
                    @click="clickCaptcha"
                    @verify="verifyCaptcha"
                ></vue-recaptcha>
                <br />
                <button v-if="showButton" class="app-btn app-btn--big app-btn-primary" @click.prevent="remindPassword">
                    {{ $t('SEND_WITHOUT_DOT') }}
                </button>
            </form>
        </div>

        <div class="text-xs-center mt-5 mb-5" v-else>
            <p class="forgot-password-sent">
                <img src="./../../../assets/images/icons/check-red.svg" />
                {{ $t('RESET_PASSWORD_LINK_SENT') }}
            </p>

            <button class="app-btn app-btn--big app-btn-primary" @click.prevent="goToLogin">
                {{ $t('GO_BACK_TO_LOGIN_PAGE') }}
            </button>
        </div>
    </section>
</template>

<script>
import { config } from './../../../main';
import VueRecaptcha from 'vue-recaptcha';
import { sha256 } from 'js-sha256';

export default {
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            siteKey: '6LdWhU0UAAAAAAtBkO-EedKZtNz8vsugSJfuI1r8',
            showButton: false,
            loginEmail: '',
            emailReminded: false,
            showCaptcha: false,
            emailRegex: config.emailRegex,
        };
    },
    methods: {
        verifyCaptcha(response) {
            if (response) {
                this.showButton = true;
            }
        },

        clickCaptcha() {
            setTimeout(() => {
                console.log('click');
            }, 1000);
        },
        remindPassword() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$http
                        .get(`${config.authUrl}/public/${sha256(this.loginEmail.toLowerCase())}/localServer`)
                        .then(
                            data => {
                                this.$http
                                    .post(
                                        data.body.localServerUrl +
                                            '/user/public/registration/initializePasswordReset?hcp=false',
                                        {
                                            email: this.loginEmail,
                                        },
                                    )
                                    .then(() => (this.emailReminded = true), () => (this.emailReminded = true));
                            },
                            () => (this.emailReminded = true),
                        );
                }
            });
        },
        goToLogin() {
            this.$router.push('logowanie');
        },
        setCaptchaLanguage() {
            /* const frame = $('#password-reminder').find('iframe');
            const lang = this.$store.state.interfaceLanguage;
            const src = frame.attr('src').replace(/hl=(.*?)&/, `hl=${lang}&`);
            frame.attr('src', src);*/
            setTimeout(() => (this.showCaptcha = true), 500);
        },
    },
    created() {
        setTimeout(() => this.setCaptchaLanguage(), 1000);
    },
};
</script>

<style lang="scss">
.set-password__container {
    width: 70%;
    max-width: 815px;
    margin-left: auto;
    margin-right: auto;
}

.set-password__heading {
    color: #706c69;
    font-weight: 500;
    display: block;
    font-size: 18px;
}

.forgot-password-sent {
    position: relative;
    padding-left: 60px;
    color: #333333;
    font-size: 18px;
    line-height: 20px;
    font-weight: 800;
    width: 400px;
    margin: 30px auto;
    text-align: left;

    img {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// password-reminder.vue?735bdd5a